export const vehicleMovementPurposeOptions = [
    {
        label: "Ενοικίαση",
        value: "1"
    },
    {
        label: "Ιδιόχρηση",
        value: "2"
    },
    {
        label: "Δωρεάν Υπηρεσία",
        value: "3"
    },
]
